// actions.js
import { TRIGGER_VAPI_BUTTON_CLICK } from './constants';

export const triggerVapiButtonClick = () => ({
    type: TRIGGER_VAPI_BUTTON_CLICK
});
